import React, { useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const AnimatedSubmitButton = ({ disabled }) => {
  const btnRef = useRef(null);

  // نضيف الـ CSS محلياً للمكوّن
  const styles = `
  .add-to-cart {
    --background-default:#17171B; --background-hover:#0A0A0C; --background-scale:1;
    --text-color:#fff; --text-o:1; --text-x:12px; --cart:#fff; --cart-x:-48px; --cart-y:0px;
    --cart-rotate:0deg; --cart-scale:.75; --cart-clip:0px; --cart-clip-x:0px; --cart-tick-offset:10px;
    --cart-tick-color:#00fffc; --shirt-y:-16px; --shirt-scale:0; --shirt-color:#17171B; --shirt-logo:#fff;
    --shirt-second-y:24px; --shirt-second-color:#fff; --shirt-second-logo:#17171B; -webkit-tap-highlight-color:transparent;
    -webkit-appearance:none; outline:none; background:none; border:none; padding:12px 0; width:164px; margin:0; cursor:pointer; position:relative;
    font-family: inherit;
  }
  .add-to-cart:before{content:"";position:absolute;inset:0;border-radius:5px;transition:background .25s;background:var(--background,var(--background-default));transform:scaleX(var(--background-scale))}
  .add-to-cart:not(.active):hover{--background:var(--background-hover)}
  .add-to-cart[disabled]{opacity:.5;cursor:not-allowed}
  .add-to-cart span{display:block;text-align:center;position:relative;z-index:1;font-size:14px;font-weight:600;line-height:24px;color:var(--text-color);opacity:var(--text-o);transform:translateX(var(--text-x))}
  .add-to-cart svg{display:block;width:var(--svg-width,24px);height:var(--svg-height,24px);position:var(--svg-position,relative);left:var(--svg-left,0);top:var(--svg-top,0);stroke-linecap:round;stroke-linejoin:round}
  .add-to-cart svg path{fill:var(--svg-fill,none);stroke:var(--svg-stroke,none);stroke-width:var(--svg-stroke-width,2)}
  .add-to-cart .morph{--svg-width:64px;--svg-height:13px;--svg-left:50%;--svg-top:-12px;--svg-position:absolute;--svg-fill:var(--background,var(--background-default));transition:fill .25s;pointer-events:none;margin-left:-32px}
  .add-to-cart .shirt,.add-to-cart .cart{pointer-events:none;position:absolute;left:50%}
  .add-to-cart .shirt{margin:-12px 0 0 -12px;top:0;transform-origin:50% 100%;transform:translateY(var(--shirt-y)) scale(var(--shirt-scale))}
  .add-to-cart .shirt svg{--svg-fill:var(--shirt-color)}
  .add-to-cart .shirt svg g{--svg-fill:var(--svg-g-fill,var(--shirt-logo))}
  .add-to-cart .shirt svg.second{--svg-fill:var(--shirt-second-color);--svg-g-fill:var(--shirt-second-logo);--svg-position:absolute;-webkit-clip-path:polygon(0 var(--shirt-second-y),24px var(--shirt-second-y),24px 24px,0 24px);clip-path:polygon(0 var(--shirt-second-y),24px var(--shirt-second-y),24px 24px,0 24px)}
  .add-to-cart .cart{--svg-width:36px;--svg-height:26px;--svg-stroke:var(--cart);top:10px;margin-left:-18px;transform:translate(var(--cart-x),var(--cart-y)) rotate(var(--cart-rotate)) scale(var(--cart-scale))}
  .add-to-cart .cart:before{content:"";display:block;width:22px;height:12px;position:absolute;left:7px;top:7px;background:var(--cart);-webkit-clip-path:polygon(0 0,22px 0,calc(22px - var(--cart-clip-x)) var(--cart-clip),var(--cart-clip-x) var(--cart-clip));clip-path:polygon(0 0,22px 0,calc(22px - var(--cart-clip-x)) var(--cart-clip),var(--cart-clip-x) var(--cart-clip))}
  .add-to-cart .cart path.wheel{--svg-stroke-width:1.5}
  .add-to-cart .cart path.tick{--svg-stroke:var(--cart-tick-color);stroke-dasharray:10px;stroke-dashoffset:var(--cart-tick-offset)}
  `;

  useEffect(() => {
    // تحميل السكربتات عند الحاجة
    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve();
        const s = document.createElement("script");
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });

    const setup = async () => {
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.4.0/gsap.min.js"
      );
      await loadScript(
        "https://s3-us-west-2.amazonaws.com/s.cdpn.io/16327/MorphSVGPlugin3.min.js"
      );
      const gsap = window.gsap;
      const MorphSVGPlugin = window.MorphSVGPlugin;
      if (!gsap || !MorphSVGPlugin || !btnRef.current) return;
      gsap.registerPlugin(MorphSVGPlugin);

      const button = btnRef.current;
      const morph = button.querySelector(".morph path");
      const shirt = button.querySelectorAll(".shirt svg > path");

      button.addEventListener("pointerdown", () => {
        if (button.classList.contains("active") || button.disabled) return;
        gsap.to(button, { "--background-scale": 0.97, duration: 0.15 });
      });

      // مهم: لا نمنع الإرسال الافتراضي (لا يوجد preventDefault)
      button.addEventListener("click", () => {
        if (button.classList.contains("active") || button.disabled) return;
        button.classList.add("active");

        gsap.to(button, {
          keyframes: [
            { "--background-scale": 0.97, duration: 0.15 },
            {
              "--background-scale": 1,
              delay: 0.125,
              duration: 1.2,
              ease: "elastic.out(1,.6)",
            },
          ],
        });

        gsap.to(button, {
          keyframes: [
            {
              "--shirt-scale": 1,
              "--shirt-y": "-42px",
              "--cart-x": "0px",
              "--cart-scale": 1,
              duration: 0.4,
              ease: "power1.in",
            },
            { "--shirt-y": "-40px", duration: 0.3 },
            {
              "--shirt-y": "16px",
              "--shirt-scale": 0.9,
              duration: 0.25,
              ease: "none",
            },
            { "--shirt-scale": 0, duration: 0.3, ease: "none" },
          ],
        });

        gsap.to(button, {
          "--shirt-second-y": "0px",
          delay: 0.835,
          duration: 0.12,
        });

        gsap.to(button, {
          keyframes: [
            {
              "--cart-clip": "12px",
              "--cart-clip-x": "3px",
              delay: 0.9,
              duration: 0.06,
            },
            { "--cart-y": "2px", duration: 0.1 },
            {
              "--cart-tick-offset": "0px",
              "--cart-y": "0px",
              duration: 0.2,
              onComplete() {
                button.style.overflow = "hidden";
              },
            },
            { "--cart-x": "52px", "--cart-rotate": "-15deg", duration: 0.2 },
            {
              "--cart-x": "104px",
              "--cart-rotate": "0deg",
              duration: 0.2,
              clearProps: true,
              onComplete() {
                button.style.overflow = "hidden";
                button.style.setProperty("--text-o", 0);
                button.style.setProperty("--text-x", "0px");
                button.style.setProperty("--cart-x", "-104px");
              },
            },
            {
              "--text-o": 1,
              "--text-x": "12px",
              "--cart-x": "-48px",
              "--cart-scale": 0.75,
              duration: 0.25,
              clearProps: true,
              onComplete() {
                button.classList.remove("active");
              },
            },
          ],
        });

        gsap.to(button, { keyframes: [{ "--text-o": 0, duration: 0.3 }] });

        gsap.to(morph, {
          keyframes: [
            {
              morphSVG:
                "M0 12C6 12 20 10 32 0C43.9024 9.99999 58 12 64 12V13H0V12Z",
              duration: 0.25,
              ease: "power1.out",
            },
            {
              morphSVG:
                "M0 12C6 12 17 12 32 12C47.9024 12 58 12 64 12V13H0V12Z",
              duration: 0.15,
              ease: "none",
            },
          ],
        });

        gsap.to(shirt, {
          keyframes: [
            {
              morphSVG:
                "M4.99997 3L8.99997 1.5C8.99997 1.5 10.6901 3 12 3C13.3098 3 15 1.5 15 1.5L19 3L23.5 8L20.5 11L19 9.5L18 22.5C18 22.5 14 21.5 12 21.5C10 21.5 5.99997 22.5 5.99997 22.5L4.99997 9.5L3.5 11L0.5 8L4.99997 3Z",
              duration: 0.25,
              delay: 0.25,
            },
            {
              morphSVG:
                "M4.99997 3L8.99997 1.5C8.99997 1.5 10.6901 3 12 3C13.3098 3 15 1.5 15 1.5L19 3L23.5 8L20.5 11L19 9.5L18.5 22.5C18.5 22.5 13.5 22.5 12 22.5C10.5 22.5 5.5 22.5 5.5 22.5L4.99997 9.5L3.5 11L0.5 8L4.99997 3Z",
              duration: 0.85,
              ease: "elastic.out(1,.5)",
            },
            {
              morphSVG:
                "M4.99997 3L8.99997 1.5C8.99997 1.5 10.6901 3 12 3C13.3098 3 15 1.5 15 1.5L19 3L22.5 8L19.5 10.5L19 9.5L17.1781 18.6093C17.062 19.1901 16.778 19.7249 16.3351 20.1181C15.4265 20.925 13.7133 22.3147 12 23C10.2868 22.3147 8.57355 20.925 7.66487 20.1181C7.22198 19.7249 6.93798 19.1901 6.82183 18.6093L4.99997 9.5L4.5 10.5L1.5 8L4.99997 3Z",
              duration: 0,
              delay: 1.25,
            },
          ],
        });
      });
    };

    setup();
  }, []);

  return (
    <>
      <style>{styles}</style>
      <button
        ref={btnRef}
        type="submit"
        disabled={disabled}
        className="add-to-cart"
        aria-label="إرسال الطلب"
        title="إرسال الطلب"
      >
        <span>{disabled ? "جاري الإرسال..." : "إرسال الطلب"}</span>

        <svg className="morph" viewBox="0 0 64 13">
          <path d="M0 12C6 12 17 12 32 12C47.9024 12 58 12 64 12V13H0V12Z" />
        </svg>

        <div className="shirt">
          <svg className="first" viewBox="0 0 24 24">
            <path d="M4.99997 3L8.99997 1.5C8.99997 1.5 10.6901 3 12 3C13.3098 3 15 1.5 15 1.5L19 3L22.5 8L19.5 10.5L19 9.5L17.1781 18.6093C17.062 19.1901 16.778 19.7249 16.3351 20.1181C15.4265 20.925 13.7133 22.3147 12 23C10.2868 22.3147 8.57355 20.925 7.66487 20.1181C7.22198 19.7249 6.93798 19.1901 6.82183 18.6093L4.99997 9.5L4.5 10.5L1.5 8L4.99997 3Z" />
            <g>
              <path d="M16.3516 9.65383H14.3484V7.83652H14.1742V9.8269H16.5258V7.83652H16.3516V9.65383Z" />
              <path d="M14.5225 6.01934V7.66357H14.6967V7.4905H14.8186V7.66357H14.9928V6.01934H14.8186V7.31742H14.6967V6.01934H14.5225Z" />
              <path d="M14.1742 5.67319V7.66357H14.3484V5.84627H16.3516V7.66357H16.5258V5.67319H14.1742Z" />
              <path d="M15.707 9.48071H15.8812V9.28084L16.0032 9.4807V9.48071H16.1774V7.83648H16.0032V9.14683L15.8812 8.94697V7.83648H15.707V9.48071Z" />
              <path d="M15.5852 6.01931H15.1149V6.19238H15.5852V6.01931Z" />
              <path d="M15.707 6.01934V7.66357H15.8812V7.46371L16.0032 7.66357H16.1774V6.01934H16.0032V7.32969L15.8812 7.12984V6.01934H15.707Z" />
              <path d="M15.411 7.31742H15.2891V6.53857H15.411V7.31742ZM15.1149 7.66357H15.2891V7.4905H15.411V7.66357H15.5852V6.3655H15.1149V7.66357Z" />
              <path d="M14.5225 8.69756L14.8186 9.18291V9.30763H14.6967V9.13455H14.5225V9.48071H14.9928V9.13456V9.13455L14.6967 8.64917V8.00956H14.8186V8.6586H14.9928V7.83648H14.5225V8.69756Z" />
              <path d="M15.411 9.30763H15.2891V8.00956H15.411V9.30763ZM15.1149 9.48071H15.5852V7.83648H15.1149V9.48071Z" />
            </g>
          </svg>
          <svg className="second" viewBox="0 0 24 24">
            <path d="M4.99997 3L8.99997 1.5C8.99997 1.5 10.6901 3 12 3C13.3098 3 15 1.5 15 1.5L19 3L22.5 8L19.5 10.5L19 9.5L17.1781 18.6093C17.062 19.1901 16.778 19.7249 16.3351 20.1181C15.4265 20.925 13.7133 22.3147 12 23C10.2868 22.3147 8.57355 20.925 7.66487 20.1181C7.22198 19.7249 6.93798 19.1901 6.82183 18.6093L4.99997 9.5L4.5 10.5L1.5 8L4.99997 3Z" />
          </svg>
        </div>

        <div className="cart">
          <svg viewBox="0 0 36 26">
            <path
              d="M1 2.5H6L10 18.5H25.5L28.5 7.5L7.5 7.5"
              className="shape"
            />
            <path
              d="M11.5 25C12.6046 25 13.5 24.1046 13.5 23C13.5 21.8954 12.6046 21 11.5 21C10.3954 21 9.5 21.8954 9.5 23C9.5 24.1046 10.3954 25 11.5 25Z"
              className="wheel"
            />
            <path
              d="M24 25C25.1046 25 26 24.1046 26 23C26 21.8954 25.1046 21 24 21C22.8954 21 22 21.8954 22 23C22 24.1046 22.8954 25 24 25Z"
              className="wheel"
            />
            <path d="M14.5 13.5L16.5 15.5L21.5 10.5" className="tick" />
          </svg>
        </div>
      </button>
    </>
  );
};

/* File Upload */
const FileUpload = ({ accept, multiple, onChange, value, placeholder }) => {
  const [dragActive, setDragActive] = React.useState(false);
  const inputRef = React.useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
    else if (e.type === "dragleave") setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const files = [...e.dataTransfer.files];
    if (files.length > 0) onChange(multiple ? files : files[0]);
  };

  const handleFileSelect = (e) => {
    const files = [...e.target.files];
    if (files.length > 0) onChange(multiple ? files : files[0]);
  };

  const getFileNames = () => {
    if (!value) return null;
    if (multiple && Array.isArray(value))
      return value.map((f) => f.name).join(", ");
    return value.name || "";
  };

  return (
    <div className="space-y-2">
      <div
        className={`relative rounded-2xl border-2 border-dashed transition-all duration-300 cursor-pointer group
          ${
            dragActive
              ? "border-[color:#936e2a] bg-[color:#936e2a]/10"
              : "border-[var(--border)] hover:bg-[color:var(--background)]"
          }`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onClick={() => inputRef.current?.click()}
      >
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          multiple={multiple}
          onChange={handleFileSelect}
          className="hidden"
        />
        <div className="px-6 py-8 text-center">
          <p
            className="text-lg font-semibold"
            style={{ color: "var(--foreground)" }}
          >
            {dragActive ? "اترك الملف هنا" : "اسحب الملف أو انقر للاختيار"}
          </p>
          <p className="text-sm" style={{ color: "var(--foreground2)" }}>
            {placeholder}
          </p>
        </div>
        {getFileNames() && (
          <div
            className="absolute bottom-2 left-2 right-2 rounded-xl"
            style={{ background: "var(--background)", padding: "8px 12px" }}
          >
            <p
              className="text-xs font-medium"
              style={{ color: "var(--foreground)" }}
            >
              📄 {getFileNames()}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

/* خيارات */
const OPTIONS = {
  sides: [
    { value: "one", label: "جهة واحدة" },
    { value: "two", label: "جهتين" },
  ],
  sizesOz: [
    { value: "6oz", label: "6oz" },
    { value: "9oz", label: "9oz" },
  ],
};

/* تخطيط بسيط */
const Section = ({ title, children, icon }) => (
  <div className="space-y-6">
    <div
      className="flex items-center gap-3 pb-4 border-b"
      style={{ borderColor: "var(--border)" }}
    >
      {icon && <span className="text-2xl">{icon}</span>}
      <h3 className="text-xl font-bold" style={{ color: "var(--foreground)" }}>
        {title}
      </h3>
    </div>
    <div className="space-y-6">{children}</div>
  </div>
);

const Field = ({ label, children }) => (
  <div className="space-y-3">
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-start">
      <div className="lg:col-span-1">
        <label
          className="block text-sm font-semibold"
          style={{ color: "var(--foreground2)" }}
        >
          {label}
        </label>
      </div>
      <div className="lg:col-span-2">{children}</div>
    </div>
  </div>
);

const TextInput = React.forwardRef(function TextInput({ className = "", ...props }, ref) {
  return (
    <input
      ref={ref}                 // ✅ مهم لـ RHF
      {...props}
      className={`w-full rounded-2xl border px-4 py-3.5 font-medium transition-all duration-300 border-[var(--border)] ${className}`}
      style={{ background: "var(--background2)", color: "var(--foreground)" }}
    />
  );
});

const TextArea = React.forwardRef(function TextArea({ className = "", rows = 4, ...props }, ref) {
  return (
    <textarea
      ref={ref}                 // ✅ مهم لـ RHF
      rows={rows}
      {...props}
      className={`w-full rounded-2xl border px-4 py-3.5 font-medium transition-all duration-300 resize-none border-[var(--border)] ${className}`}
      style={{ background: "var(--background2)", color: "var(--foreground)" }}
    />
  );
});

/* كروت الاختيار */
const CardSelector = ({ options, value, onChange, multi = false }) => {
  const toggle = (val) => {
    if (multi) {
      const arr = Array.isArray(value) ? [...value] : [];
      if (arr.includes(val)) onChange(arr.filter((v) => v !== val));
      else onChange([...arr, val]);
    } else {
      onChange(val);
    }
  };
  return (
    <div className="flex flex-wrap gap-3">
      {options.map((opt) => {
        const active = multi ? value?.includes(opt.value) : value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => toggle(opt.value)}
            className="px-4 py-2 rounded-xl border text-sm font-medium transition"
            style={{
              background: active ? "rgba(0,128,0,0.2)" : "var(--background)",
              borderColor: "var(--border)",
              color: "var(--foreground)",
            }}
          >
            {opt.label} {active && "✓"}
          </button>
        );
      })}
    </div>
  );
};

/* Logo */
const Logo = () => (
  <div className="text-center mb-8">
    <div className="inline-flex items-center justify-center w-56 h-20 mb-4">
      <img
        src="/logo.svg"
        alt="شعار الشركة"
        className="h-full w-auto object-contain"
      />
    </div>
    <h1
      className="text-3xl font-bold"
      style={{
        backgroundImage: "linear-gradient(90deg,#936e2a,#c8a97e,#e6d5b8)",
        WebkitBackgroundClip: "text",
        color: "transparent",
      }}
    >
      نموذج طلب التصميم
    </h1>
    <p style={{ color: "var(--foreground2)" }} className="mt-2">
      املأ النموذج لطلب تصميمك المخصص
    </p>
  </div>
);

export default function DesignRequestForm() {
  const navigate = useNavigate();
  const orderIdRef = React.useRef(`ORD-${Date.now()}`);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const { control, register, handleSubmit, reset } = useForm({
    defaultValues: {
      customerName: "",
      companyName: "",
      logoPdf: null,
      orderNumber: orderIdRef.current,
      sloganAr: "",
      sloganEn: "",
      designSketch: "",
      sides: "one",
      sizeOz: [],
      pantoneColor: "",
      fontName: "",
      attachments: null,
    },
  });

  const handleReset = () => {
    orderIdRef.current = `ORD-${Date.now()}`;
    reset({
      customerName: "",
      companyName: "",
      logoPdf: null,
      orderNumber: orderIdRef.current,
      sloganAr: "",
      sloganEn: "",
      designSketch: "",
      sides: "one",
      sizeOz: [],
      pantoneColor: "",
      fontName: "",
      attachments: null,
    });
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("customerName", data.customerName || "");
      fd.append("companyName", data.companyName || "");
      fd.append("orderNumber", orderIdRef.current);
      fd.append("sloganAr", data.sloganAr || "");
      fd.append("sloganEn", data.sloganEn || "");
      fd.append("designSketch", data.designSketch || "");
      fd.append("sides", data.sides || "");
      fd.append(
        "sizeOz",
        JSON.stringify(Array.isArray(data.sizeOz) ? data.sizeOz : [])
      );
      fd.append("pantoneColor", data.pantoneColor || "");
      fd.append("fontName", data.fontName || "");
      if (data.logoPdf) fd.append("logoPdf", data.logoPdf); // يقبل أي نوع
      if (data.attachments && data.attachments.length > 0) {
        Array.from(data.attachments).forEach((f) =>
          fd.append("attachments", f)
        );
      }
      for (const [k, v] of fd.entries()) {
        console.log(k, v instanceof File ? `File(${v.name})` : v);
      }
      const response = await fetch(
        "https://api.cups.ahlamcoffee.com/api/submit-telegram",
        { method: "POST", body: fd }
      );

      // تحمّل كل الحالات + بديل للـ orderNo
      let result;
      try {
        result = await response.json();
      } catch {
        result = null;
      }

      if (response.ok && result?.success) {
        const serverOrderNo = result?.data?.orderNo || orderIdRef.current;
        // لا نعرض alert الآن، سنحوّل لصفحة النجاح
        handleReset();
        setTimeout(() => {
          navigate(`/success?order=${encodeURIComponent(serverOrderNo)}`);
        }, 1500);
      } else {
        const msg = result?.message || `HTTP ${response.status}`;
        throw new Error(msg || "تعذر الإرسال");
      }
    } catch (error) {
      console.error("خطأ في الإرسال:", error);
      alert(`خطأ في الإرسال: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const { control: c2 } = { control }; // فقط لتفادي تحذيرات استخدام غير مباشر

  return (
    <div
      className="min-h-screen"
      style={{
        background: "linear-gradient(135deg,#1a0f0a,#24150e,#2e1d12)",
        padding: 16,
        borderRadius: 16,
        border: "1px solid var(--border)",
      }}
    >
      <div className="max-w-4xl mx-auto">
        <Logo />
        <form
          dir="rtl"
          onSubmit={handleSubmit(onSubmit)}
          className="rounded-3xl border p-6 md:p-8 space-y-12"
          style={{
            background: "var(--background2)",
            borderColor: "var(--border)",
          }}
        >
          {/* البيانات الأساسية */}
          <Section title="البيانات الأساسية">
            <Field label="اسم العميل">
              <TextInput
                placeholder="الاسم الكامل (اختياري)"
                {...register("customerName")}
              />
            </Field>
            <Field label="اسم الشركة">
              <TextInput
                placeholder="اسم الشركة (اختياري)"
                {...register("companyName")}
              />
            </Field>

            {/* ✅ الشعار يقبل أي نوع */}
            <Field label="الشعار (أي نوع ملف)">
              <Controller
                name="logoPdf"
                control={control}
                render={({ field }) => (
                  <FileUpload
                    accept="*/*"
                    placeholder="اختر ملف الشعار (اختياري — أي نوع)"
                    onChange={field.onChange}
                    value={field.value}
                  />
                )}
              />
            </Field>

            <Field label="رقم الطلب">
              <TextInput
                value={orderIdRef.current}
                disabled
                className="cursor-not-allowed opacity-80"
              />
            </Field>
          </Section>

          {/* محتوى التصميم */}
          <Section title="محتوى التصميم">
            <Field label="العبارة (عربي)">
              <TextInput
                placeholder="اكتب العبارة المطلوبة بالعربية (اختياري)"
                {...register("sloganAr")}
              />
            </Field>
            <Field label="العبارة (إنجليزي)">
              <TextInput
                placeholder="Write the required text in English (optional)"
                {...register("sloganEn")}
              />
            </Field>
            <Field label="وصف التصميم">
              <TextArea
                placeholder="وصف التصميم أو رابط مرجعي (اختياري)"
                {...register("designSketch")}
              />
            </Field>
          </Section>

          {/* مواصفات المنتج */}
          <Section title="مواصفات المنتج">
            <Field label="كم جهة">
              <Controller
                control={control}
                name="sides"
                render={({ field }) => (
                  <CardSelector
                    options={OPTIONS.sides}
                    value={field.value}
                    onChange={field.onChange}
                    multi={false}
                  />
                )}
              />
            </Field>
            <Field label="كم القياس">
              <Controller
                control={control}
                name="sizeOz"
                render={({ field }) => (
                  <CardSelector
                    options={OPTIONS.sizesOz}
                    value={field.value}
                    onChange={field.onChange}
                    multi={true}
                  />
                )}
              />
            </Field>
            <Field label="كود اللون (بانتون)">
              <TextInput
                placeholder="مثال: PANTONE 186 C (اختياري)"
                {...register("pantoneColor")}
              />
            </Field>
            <Field label="نوع الخط">
              <TextInput
                placeholder="مثال: Arial Bold أو خط مخصص (اختياري)"
                {...register("fontName")}
              />
            </Field>
          </Section>

          {/* الملفات المرفقة */}
          <Section title="الملفات المرفقة" icon="📎">
            <Field label="ملفات إضافية">
              <Controller
                name="attachments"
                control={control}
                render={({ field }) => (
                  <FileUpload
                    accept="application/pdf,.jpg,.jpeg,.png,.ai,.psd"
                    multiple
                    placeholder="PDF، صور، أو ملفات التصميم (اختياري)"
                    onChange={field.onChange}
                    value={field.value}
                  />
                )}
              />
            </Field>
          </Section>

          {/* الأزرار */}
          <div className="flex flex-col sm:flex-row items-center justify-center pt-2 pb-5">
            <AnimatedSubmitButton disabled={isSubmitting} />
            {/*<button
              type="button"
              onClick={handleReset}
              disabled={isSubmitting}
              className="rounded-2xl  px-6 py-4 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
              style={{
                borderColor: "var(--border)",
                color: "var(--foreground)",
                background: "transparent",
              }}
            >
              تفريغ النموذج
            </button>*/}
          </div>
        </form>
      </div>
    </div>
  );
}
